"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineCustomElement = defineCustomElement;
const jsx_runtime_1 = require("./jsx-runtime");
function defineCustomElement(name, constructor, options) {
    customElements.define(name, constructor, options);
    return (props) => (0, jsx_runtime_1.jsx)(name, props);
}
